module.exports = __webpack_public_path__ + "static/img/comshow_three.d540f73e.jpg";